<template>
    <section class="section section--testimonials" id="testimonials">
        <Heading text="Naši klienti" />
        <ul class="section__testimonials">
            <li class="section__testimonial" v-for="testimonial in testimonials" v-bind:key="testimonial.name">
                <Testimonial :portrait="testimonial.portrait" :name="testimonial.name"  :company="testimonial.company" :text="testimonial.text" />
            </li>
        </ul>
    </section>
</template>

<script>
    import Heading from './includes/Heading.vue';
    import Testimonial from './includes/Testimonial.vue';

    export default {
        name: 'Testimonials',
        components: {
            Heading,
            Testimonial
        },
        data() {
            return {
                testimonials: [
                    {
                        portrait: 'testimonial-1',
                        name: 'Jiří Halousek, MBA',
                        company: 'IRESOFT s.r.o.',
                        text: 'S institutem spolupracuji už řadu let a celou tu dobu nám pomáhá se rozvíjet a být kompetentnější. Stále se učíme, zpřesňujeme naše hodnoty a očekávání a posilujeme svoje identity, abychom věděli, kým jsme, kam jdeme a hlavně proč. Je to cesta, která mi dává smysl a dělá mi radost, když vidím, jak se celá firma i jednotlivci posouvají, ať už v práci nebo i v osobním životě.'
                    },
                    {
                        portrait: 'testimonial-2',
                        name: 'Ing. Jakub Javorský',
                        company: 'Benefit investment a.s.',
                        text: 'Jelikož jsme dynamicky rozvíjející se společností, která neustále roste v průměru 30 % p.a., tak potřebujeme mít v Benefit Investment a.s. dobře nastavený systém, který náš vývoj podpoří. Díky spolupráci s Dr., Mgr. et Mgr. Petrem Pacherem, Ph.D., MBA a Mgr. et Mgr. Michaelou Píškovou, MBA nastavujeme v celé firmě pevný základ, na kterém můžeme nadále stavět úspěšnou firmu.'
                    },
                    {
                        portrait: 'testimonial-3',
                        name: 'Ing. Pavel Rieder',
                        company: 'JULI Motorenwerk s.r.o.',
                        text: 'S Institutem Aplikované Psychologie dlouhodobě spolupracujeme na rozvoji našich projektových manažerů. Díky individuální i skupinové práci s Míšou Píškovou, ředitelkou Institutu se stali naši zaměstnanci výrazně kompetentnějšími pro výkon svých pracovních rolí, což přispívá k jejich spokojenosti i kvalitě jejich výsledků.'
                    },
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {

        &__testimonials {
            display: flex;
            justify-content: space-between;
            max-width: 120rem;
            padding-left: 0;
            margin: 6rem auto 0 auto;
            list-style-type: none;
        }

        &__testimonial {
            width: 29%;
        }
    }

    @media (max-width: 767px) {

        .section {

            &__testimonials {
                flex-wrap: wrap;
            }

            &__testimonial {
                width: 100%;

                &:not(:last-of-type) {
                    margin-bottom: 6rem;
                }
            }
        }
    }

</style>
